import { render } from "./Quizz2DStep.vue?vue&type=template&id=6f1621ab&scoped=true"
import script from "./Quizz2DStep.vue?vue&type=script&lang=js"
export * from "./Quizz2DStep.vue?vue&type=script&lang=js"

import "./Quizz2DStep.vue?vue&type=style&index=0&id=6f1621ab&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f1621ab"]])

export default __exports__